import { render, staticRenderFns } from "./BannerManage.vue?vue&type=template&id=972197a8&"
import script from "./BannerManage.vue?vue&type=script&lang=js&"
export * from "./BannerManage.vue?vue&type=script&lang=js&"
import style0 from "./BannerManage.vue?vue&type=style&index=0&id=972197a8&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Jenkins_Home\\workspace\\liveinfo3-front-admin-dev\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('972197a8')) {
      api.createRecord('972197a8', component.options)
    } else {
      api.reload('972197a8', component.options)
    }
    module.hot.accept("./BannerManage.vue?vue&type=template&id=972197a8&", function () {
      api.rerender('972197a8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/apps/contents/banner-manage/BannerManage.vue"
export default component.exports